import { type RouteObject } from 'react-router';

export const routes: RouteObject[] = [
    {
        path: '*',
        children: [
            {
                path: '*',
                lazy: async () => {
                    const { Editor } = await import('@@routes/plate/Editor');

                    return { Component: Editor };
                },
            },
        ],
    },
];
